import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
export var LocalStoreService = /*#__PURE__*/function () {
  function LocalStoreService(storage) {
    _classCallCheck(this, LocalStoreService);
    try {
      this.storage = storage || window.localStorage;
    } catch (_unused) {
      this.storage = undefined;
    }
    this.isEnabled = this.checkStorageEnabled();
  }
  return _createClass(LocalStoreService, [{
    key: "checkStorageEnabled",
    value: function checkStorageEnabled() {
      if (!this.storage) return false;
      var testKey = 'localStorageCheck';
      var testValue = 'just checking';
      try {
        this.set(testKey, testValue);
        return this.get(testKey) === testValue;
      } catch (_unused2) {
        return false;
      }
    }
  }, {
    key: "get",
    value: function get(key) {
      return this.storage.getItem(key);
    }
  }, {
    key: "set",
    value: function set(key, value) {
      return value ? this.storage.setItem(key, value) : this.remove(key);
    }
  }, {
    key: "remove",
    value: function remove(key) {
      return this.storage.removeItem(key);
    }
  }]);
}();
export default LocalStoreService;